import api from './api';

export const installmentService = {
  getAll: async (includeCompleted = false) => {
    return api.get('/installments', { params: { includeCompleted } });
  },

  getById: async (installmentId) => {
    return api.get(`/installments/${installmentId}`);
  },

  create: async (data) => {
    return api.post('/installments', data);
  },

  update: async (installmentId, data) => {
    return api.put(`/installments/${installmentId}`, data);
  },

  delete: async (installmentId) => {
    return api.delete(`/installments/${installmentId}`);
  },

  pay: async (installmentId, installmentNumber, paymentDate) => {
    return api.post(`/installments/${installmentId}/pay`, {
      installmentNumber,
      paymentDate,
    });
  },

  getSchedule: async (installmentId) => {
    return api.get(`/installments/${installmentId}/schedule`);
  },
};

export default installmentService;
